import { ROUTE_NAME } from '@/router/utils/const'

export const CUSTOM_PASSWORD_PROVIDED = 'custom:password_provided'
export const USERNAME_KEY = 'cognito:username'

export const REDIRECT_AVOID_ROUTES = [
  ROUTE_NAME.INDEX,
  ROUTE_NAME.SIGNIN,
  ROUTE_NAME.SIGNIN_CONFIRMATION,
  ROUTE_NAME.SIGNUP,
  ROUTE_NAME.SIGNUP_CONFIRMATION,
  ROUTE_NAME.FORGOT,
  ROUTE_NAME.PASSWORD,
  ROUTE_NAME.CONFIRM,
  ROUTE_NAME.TERMS,
  ROUTE_NAME.POLICY,
  ROUTE_NAME.PERMISSION_DENIED,
  ROUTE_NAME.UPGRADE_PLAN,
]
